import { Uuid } from "../../domain/model/uuid/uuid.type";
import { IdNameBaseViewModel } from "./id-name-base.viewmodel";

export class SectionViewModel extends IdNameBaseViewModel {
  constructor(
    id: Uuid,
    name: string) {
      super(id, name);
  }
}